/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AggregationType } from '../models/AggregationType'
import type { CensusResultModel } from '../models/CensusResultModel'
import type { CreateLayerBody } from '../models/CreateLayerBody'
import type { CurbLengthStatisticsResponseModel } from '../models/CurbLengthStatisticsResponseModel'
import type { Deployments } from '../models/Deployments'
import type { LayerResponse } from '../models/LayerResponse'
import type { ListLayersPayload } from '../models/ListLayersPayload'
import type { ListLayersResponseModel } from '../models/ListLayersResponseModel'
import type { Page_DeploymentsByShape_ } from '../models/Page_DeploymentsByShape_'
import type { Page_LayerResponse_ } from '../models/Page_LayerResponse_'
import type { Page_ParkingCountByShape_ } from '../models/Page_ParkingCountByShape_'
import type { ParkingCounts } from '../models/ParkingCounts'
import type { TimePeriodType } from '../models/TimePeriodType'
import type { TotalTripsByShape } from '../models/TotalTripsByShape'
import type { UpdateLayerBody } from '../models/UpdateLayerBody'
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class LayersService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @deprecated
   * List Layers Deprecated
   * Returns shape_layers for a specific region, which must be specified
   * on the request as region_id.
   * @returns ListLayersResponseModel Successful Response
   * @throws ApiError
   */
  public listLayersDeprecated({
    requestBody,
  }: {
    requestBody: ListLayersPayload
  }): CancelablePromise<ListLayersResponseModel> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/layers/list',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Layers
   * Returns shape_layers for a specific region
   * @returns Page_LayerResponse_ Successful Response
   * @throws ApiError
   */
  public getLayers({
    regionId,
    page = 1,
    size = 50,
    shapeLayerUuid,
    layerName,
    layerSlug,
    level,
    intersectRoute,
    vehicleCounts,
    vehicleCountsStatus,
    editable,
    search,
    orderBy,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    page?: number
    size?: number
    shapeLayerUuid?: string | null
    layerName?: string | null
    layerSlug?: string | null
    level?: string | null
    intersectRoute?: boolean | null
    vehicleCounts?: boolean | null
    vehicleCountsStatus?: string | null
    editable?: boolean | null
    search?: string | null
    orderBy?: string | null
  }): CancelablePromise<Page_LayerResponse_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers',
      path: {
        region_id: regionId,
      },
      query: {
        page: page,
        size: size,
        shape_layer_uuid: shapeLayerUuid,
        layer_name: layerName,
        layer_slug: layerSlug,
        level: level,
        intersect_route: intersectRoute,
        vehicle_counts: vehicleCounts,
        vehicle_counts_status: vehicleCountsStatus,
        editable: editable,
        search: search,
        order_by: orderBy,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Create Layer
   * Add a layer to the shape_layers table.
   * @returns LayerResponse Successful Response
   * @throws ApiError
   */
  public createLayer({
    regionId,
    requestBody,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    requestBody: CreateLayerBody
  }): CancelablePromise<LayerResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/regions/{region_id}/layers',
      path: {
        region_id: regionId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Layer
   * Retrieve a layer by slug, only showing it if it is available for the requesting user
   * @returns LayerResponse Successful Response
   * @throws ApiError
   */
  public getLayer({
    regionId,
    shapeLayerUuid,
    accept = 'application/json',
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    accept?: string
  }): CancelablePromise<LayerResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      headers: {
        accept: accept,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Delete Layer
   * Delete a shape from the shapes table.
   * @returns void
   * @throws ApiError
   */
  public deleteLayer({
    regionId,
    shapeLayerUuid,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
  }): CancelablePromise<void> {
    return this.httpRequest.request({
      method: 'DELETE',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Update Layer
   * Modify an existing shape in the shapes table. Can be used to modify the shape name.
   * @returns LayerResponse Successful Response
   * @throws ApiError
   */
  public updateLayer({
    regionId,
    shapeLayerUuid,
    requestBody,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    requestBody: UpdateLayerBody
  }): CancelablePromise<LayerResponse> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Layer Vector
   * Retrieve a layer by slug, only showing it if it is available for the requesting user as an MVT
   * @returns string Successful Response
   * @throws ApiError
   */
  public getLayerVector({
    regionId,
    shapeLayerUuid,
    z,
    x,
    y,
    ifModifiedSince,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    z: number
    x: number
    y: number
    ifModifiedSince?: string | null
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/vector/{z}/{x}/{y}',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
        z: z,
        x: x,
        y: y,
      },
      query: {
        if_modified_since: ifModifiedSince,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Does Layer Have Policies
   * Returns whether a shape layer has any non-deleted policies (v1 or v2) attached to it
   * @returns boolean Successful Response
   * @throws ApiError
   */
  public getDoesLayerHavePolicies({
    regionId,
    shapeLayerUuid,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
  }): CancelablePromise<boolean> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/has_policies',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Curb Length Statistics By Layer
   * Returns the total length and space count for all zones in the layer.
   * Optionally filtered by a list of shape ids in that layer, or by a boundary
   * shape or layer.
   * @returns CurbLengthStatisticsResponseModel Successful Response
   * @throws ApiError
   */
  public getCurbLengthStatisticsByLayer({
    regionId,
    shapeLayerUuid,
    shapeUuids,
    boundaryShapeLayerUuid,
    boundaryShapeUuids,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Optional list of shape uuids to filter with
     */
    shapeUuids?: Array<string> | null
    /**
     * Optional shape layer boundary by which to filter the curb shapes
     */
    boundaryShapeLayerUuid?: string | null
    /**
     * Optional shape boundary by which to filter the curb shapes
     */
    boundaryShapeUuids?: Array<string> | null
  }): CancelablePromise<CurbLengthStatisticsResponseModel> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/curb_length_statistics',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        shape_uuids: shapeUuids,
        boundary_shape_layer_uuid: boundaryShapeLayerUuid,
        boundary_shape_uuids: boundaryShapeUuids,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Census Data For Shape Layer
   * @returns CensusResultModel Successful Response
   * @throws ApiError
   */
  public getCensusDataForShapeLayer({
    regionId,
    shapeLayerUuid,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
  }): CancelablePromise<Record<string, CensusResultModel>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/census',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Trips By Shape
   * Aggregate trip origin info by geographies.
   * A note on dates: this endpoint offers daily resolution only.
   * start_date and end_date are truncated to their day component and
   * each is treated inclusively, as if the client had asked for the entirety
   * of the specified day. To get only one day of data the client should
   * specify start_date and end_date as the same value.
   * @returns TotalTripsByShape Successful Response
   * @throws ApiError
   */
  public getTripsByShape({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    timePeriodType,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Start date filter
     */
    startDate: string
    /**
     * End date filter
     */
    endDate: string
    /**
     * Time period for aggregation
     */
    timePeriodType: TimePeriodType
  }): CancelablePromise<Array<TotalTripsByShape>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/trips/by_shape',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        time_period_type: timePeriodType,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Deployments By Shape
   * Compute an "average daily deployments by shape" metric.
   *
   * A note on dates: this endpoint offers daily resolution only.
   * start_date and end_date are truncated to their day component and
   * each is treated inclusively, as if the client had asked for the entirety
   * of the specified day. To get only one day of data the client should
   * specify start_date and end_date as the same value.
   * @returns Page_DeploymentsByShape_ Successful Response
   * @throws ApiError
   */
  public getDeploymentsByShape({
    shapeLayerUuid,
    regionId,
    startDate,
    endDate,
    page = 1,
    size = 50,
    operators,
    vehicleTypes,
    startTime,
    endTime,
  }: {
    /**
     * Shape layer identifier
     */
    shapeLayerUuid: string
    /**
     * Region identifier
     */
    regionId: string
    startDate: string
    endDate: string
    /**
     * Page number
     */
    page?: number
    /**
     * Page size
     */
    size?: number
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of vehicle types
     */
    vehicleTypes?: Array<string> | null
    /**
     * Filter for records that start on or after the provided hour (0-23)
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided hour (0-23)
     */
    endTime?: number | null
  }): CancelablePromise<Page_DeploymentsByShape_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/deployments/by_shape',
      path: {
        shape_layer_uuid: shapeLayerUuid,
        region_id: regionId,
      },
      query: {
        page: page,
        size: size,
        start_date: startDate,
        end_date: endDate,
        operators: operators,
        vehicle_types: vehicleTypes,
        start_time: startTime,
        end_time: endTime,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Deployments Vector Tiles
   * Compute an "average daily deployments by shape" metric, in MVT form.
   *
   * A note on dates: this endpoint offers daily resolution only.
   * start_date and end_date are truncated to their day component and
   * each is treated inclusively, as if the client had asked for the entirety
   * of the specified day. To get only one day of data the client should
   * specify start_date and end_date as the same value.
   * @returns string Successful Response
   * @throws ApiError
   */
  public getDeploymentsVectorTiles({
    shapeLayerUuid,
    regionId,
    z,
    x,
    y,
    startDate,
    endDate,
    includeCensusData = false,
    operators,
    vehicleTypes,
    startTime,
    endTime,
    ifModifiedSince,
  }: {
    /**
     * Shape layer identifier
     */
    shapeLayerUuid: string
    /**
     * Region identifier
     */
    regionId: string
    z: number
    x: number
    y: number
    startDate: string
    endDate: string
    /**
     * Include census data in the response
     */
    includeCensusData?: boolean
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of vehicle types
     */
    vehicleTypes?: Array<string> | null
    /**
     * Filter for records that start on or after the provided hour (0-23)
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided hour (0-23)
     */
    endTime?: number | null
    ifModifiedSince?: string | null
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/deployments/vector/{z}/{x}/{y}',
      path: {
        shape_layer_uuid: shapeLayerUuid,
        region_id: regionId,
        z: z,
        x: x,
        y: y,
      },
      query: {
        include_census_data: includeCensusData,
        start_date: startDate,
        end_date: endDate,
        operators: operators,
        vehicle_types: vehicleTypes,
        start_time: startTime,
        end_time: endTime,
        if_modified_since: ifModifiedSince,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Deployments Legend Values
   * Compute a list of counts (one per shape) for deployments in a given shape layer,
   * given the filters.
   * @returns number Successful Response
   * @throws ApiError
   */
  public getDeploymentsLegendValues({
    shapeLayerUuid,
    regionId,
    startDate,
    endDate,
    operators,
    vehicleTypes,
    startTime,
    endTime,
  }: {
    /**
     * Shape layer identifier
     */
    shapeLayerUuid: string
    /**
     * Region identifier
     */
    regionId: string
    startDate: string
    endDate: string
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of vehicle types
     */
    vehicleTypes?: Array<string> | null
    /**
     * Filter for records that start on or after the provided hour (0-23)
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided hour (0-23)
     */
    endTime?: number | null
  }): CancelablePromise<Array<number>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/deployments/legend_values',
      path: {
        shape_layer_uuid: shapeLayerUuid,
        region_id: regionId,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        operators: operators,
        vehicle_types: vehicleTypes,
        start_time: startTime,
        end_time: endTime,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Deployments
   * Compute two figures: the total count of deployments, and the percentage of
   * total deployments that occurred in the specified shape layer.
   * @returns Deployments Successful Response
   * @throws ApiError
   */
  public getDeployments({
    shapeLayerUuid,
    regionId,
    startDate,
    endDate,
    operators,
    vehicleTypes,
    startTime,
    endTime,
  }: {
    /**
     * Shape layer identifier
     */
    shapeLayerUuid: string
    /**
     * Region identifier
     */
    regionId: string
    startDate: string
    endDate: string
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of vehicle types
     */
    vehicleTypes?: Array<string> | null
    /**
     * Filter for records that start on or after the provided hour (0-23)
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided hour (0-23)
     */
    endTime?: number | null
  }): CancelablePromise<Deployments> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/deployments',
      path: {
        shape_layer_uuid: shapeLayerUuid,
        region_id: regionId,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        operators: operators,
        vehicle_types: vehicleTypes,
        start_time: startTime,
        end_time: endTime,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Deployments By Shape And Day
   * Compute a "sum daily deployments by shape" metric.
   * @returns any Successful Response
   * @throws ApiError
   */
  public getDeploymentsByShapeAndDay({
    shapeLayerUuid,
    regionId,
    startDate,
    endDate,
    operators,
    vehicleTypes,
    startTime,
    endTime,
    accept = 'application/geo+json',
  }: {
    /**
     * Shape layer identifier
     */
    shapeLayerUuid: string
    /**
     * Region identifier
     */
    regionId: string
    startDate: string
    endDate: string
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of vehicle types
     */
    vehicleTypes?: Array<string> | null
    /**
     * Filter for records that start on or after the provided hour (0-23)
     */
    startTime?: number | null
    /**
     * Filter for records that start on or before the provided hour (0-23)
     */
    endTime?: number | null
    accept?: string
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/deployments/by_shape_and_day',
      path: {
        shape_layer_uuid: shapeLayerUuid,
        region_id: regionId,
      },
      headers: {
        accept: accept,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        operators: operators,
        vehicle_types: vehicleTypes,
        start_time: startTime,
        end_time: endTime,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking By Shape
   * Aggregate parking events or durations by shape.
   *
   * A note on dates: this endpoint offers daily resolution only.
   * start_date and end_date are truncated to their day component and
   * each is treated inclusively, as if the client had asked for the entirety
   * of the specified day. To get only one day of data the client should
   * specify start_date and end_date as the same value.
   * @returns Page_ParkingCountByShape_ Successful Response
   * @throws ApiError
   */
  public getParkingByShape({
    shapeLayerUuid,
    regionId,
    aggregation,
    startDate,
    endDate,
    startTime,
    endTime,
    page = 1,
    size = 50,
    operators,
    vehicleTypes,
    parkedDuration,
  }: {
    /**
     * Shape layer identifier
     */
    shapeLayerUuid: string
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Aggregation type
     */
    aggregation: AggregationType
    startDate: string
    endDate: string
    /**
     * Filter for records that start on or after the provided hour (0-23)
     */
    startTime: number
    /**
     * Filter for records that start before the provided hour (0-24)
     */
    endTime: number
    /**
     * Page number
     */
    page?: number
    /**
     * Page size
     */
    size?: number
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of vehicle types
     */
    vehicleTypes?: Array<string> | null
    /**
     * Filter for records with a duration in some open-ended range.
     * This option is specified as a number of minutes and possible values are
     * pre-configured using the parking_duration_filters column of the shape_layer table.
     */
    parkedDuration?: number | null
  }): CancelablePromise<Page_ParkingCountByShape_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking/by_shape',
      path: {
        shape_layer_uuid: shapeLayerUuid,
        region_id: regionId,
      },
      query: {
        aggregation: aggregation,
        page: page,
        size: size,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        operators: operators,
        vehicle_types: vehicleTypes,
        parked_duration: parkedDuration,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Vector Tiles
   * Compute parking events or durations in MVT form.
   *
   * A note on dates: this endpoint offers daily resolution only.
   * start_date and end_date are truncated to their day component and
   * each is treated inclusively, as if the client had asked for the entirety
   * of the specified day. To get only one day of data the client should
   * specify start_date and end_date as the same value.
   * @returns string Successful Response
   * @throws ApiError
   */
  public getParkingVectorTiles({
    shapeLayerUuid,
    regionId,
    z,
    x,
    y,
    aggregation,
    startDate,
    endDate,
    startTime,
    endTime,
    includeCensusData = false,
    operators,
    vehicleTypes,
    parkedDuration,
    ifModifiedSince,
  }: {
    /**
     * Shape layer identifier
     */
    shapeLayerUuid: string
    /**
     * Region identifier
     */
    regionId: string
    z: number
    x: number
    y: number
    /**
     * Aggregation type
     */
    aggregation: AggregationType
    startDate: string
    endDate: string
    /**
     * Filter for records that start on or after the provided hour (0-23)
     */
    startTime: number
    /**
     * Filter for records that start before the provided hour (0-24)
     */
    endTime: number
    /**
     * Include census data in the response
     */
    includeCensusData?: boolean
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of vehicle types
     */
    vehicleTypes?: Array<string> | null
    /**
     * Filter for records with a duration in some open-ended range.
     * This option is specified as a number of minutes and possible values are
     * pre-configured using the parking_duration_filters column of the shape_layer table.
     */
    parkedDuration?: number | null
    ifModifiedSince?: string | null
  }): CancelablePromise<string> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking/vector/{z}/{x}/{y}',
      path: {
        shape_layer_uuid: shapeLayerUuid,
        region_id: regionId,
        z: z,
        x: x,
        y: y,
      },
      query: {
        aggregation: aggregation,
        include_census_data: includeCensusData,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        operators: operators,
        vehicle_types: vehicleTypes,
        parked_duration: parkedDuration,
        if_modified_since: ifModifiedSince,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking Legend Values
   * Compute a list of counts (one per shape) for parking events or durations in a
   * given shape layer, given the filters.
   * @returns number Successful Response
   * @throws ApiError
   */
  public getParkingLegendValues({
    shapeLayerUuid,
    regionId,
    aggregation,
    startDate,
    endDate,
    startTime,
    endTime,
    operators,
    vehicleTypes,
    parkedDuration,
  }: {
    /**
     * Shape layer identifier
     */
    shapeLayerUuid: string
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Aggregation type
     */
    aggregation: AggregationType
    startDate: string
    endDate: string
    /**
     * Filter for records that start on or after the provided hour (0-23)
     */
    startTime: number
    /**
     * Filter for records that start before the provided hour (0-24)
     */
    endTime: number
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of vehicle types
     */
    vehicleTypes?: Array<string> | null
    /**
     * Filter for records with a duration in some open-ended range.
     * This option is specified as a number of minutes and possible values are
     * pre-configured using the parking_duration_filters column of the shape_layer table.
     */
    parkedDuration?: number | null
  }): CancelablePromise<Array<number>> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking/legend_values',
      path: {
        shape_layer_uuid: shapeLayerUuid,
        region_id: regionId,
      },
      query: {
        aggregation: aggregation,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        operators: operators,
        vehicle_types: vehicleTypes,
        parked_duration: parkedDuration,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking
   * Compute two figures: the total count of parking events and the percentage of
   * total parking events or duration that occurred in the specified shape layer.
   * @returns ParkingCounts Successful Response
   * @throws ApiError
   */
  public getParking({
    shapeLayerUuid,
    regionId,
    aggregation,
    startDate,
    endDate,
    startTime,
    endTime,
    operators,
    vehicleTypes,
    parkedDuration,
  }: {
    /**
     * Shape layer identifier
     */
    shapeLayerUuid: string
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Aggregation type
     */
    aggregation: AggregationType
    startDate: string
    endDate: string
    /**
     * Filter for records that start on or after the provided hour (0-23)
     */
    startTime: number
    /**
     * Filter for records that start before the provided hour (0-24)
     */
    endTime: number
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of vehicle types
     */
    vehicleTypes?: Array<string> | null
    /**
     * Filter for records with a duration in some open-ended range.
     * This option is specified as a number of minutes and possible values are
     * pre-configured using the parking_duration_filters column of the shape_layer table.
     */
    parkedDuration?: number | null
  }): CancelablePromise<ParkingCounts> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking',
      path: {
        shape_layer_uuid: shapeLayerUuid,
        region_id: regionId,
      },
      query: {
        aggregation: aggregation,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        operators: operators,
        vehicle_types: vehicleTypes,
        parked_duration: parkedDuration,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Parking By Shape And Day
   * Compute a "sum daily parking events by shape" metric.
   * @returns any Successful Response
   * @throws ApiError
   */
  public getParkingByShapeAndDay({
    shapeLayerUuid,
    regionId,
    startDate,
    endDate,
    startTime,
    endTime,
    operators,
    vehicleTypes,
    parkedDuration,
    accept = 'application/geo+json',
  }: {
    /**
     * Shape layer identifier
     */
    shapeLayerUuid: string
    /**
     * Region identifier
     */
    regionId: string
    startDate: string
    endDate: string
    /**
     * Filter for records that start on or after the provided hour (0-23)
     */
    startTime: number
    /**
     * Filter for records that start before the provided hour (0-24)
     */
    endTime: number
    /**
     * Filter for records that are in this list of operators
     */
    operators?: Array<string> | null
    /**
     * Filter for records that are in this list of vehicle types
     */
    vehicleTypes?: Array<string> | null
    /**
     * Filter for records with a duration in some open-ended range.
     * This option is specified as a number of minutes and possible values are
     * pre-configured using the parking_duration_filters column of the shape_layer table.
     */
    parkedDuration?: number | null
    accept?: string
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/layers/{shape_layer_uuid}/parking/by_shape_and_day',
      path: {
        shape_layer_uuid: shapeLayerUuid,
        region_id: regionId,
      },
      headers: {
        accept: accept,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
        operators: operators,
        vehicle_types: vehicleTypes,
        parked_duration: parkedDuration,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
}
